define([
	"csi/def/ActionFactory",
	"csi/widget/MessageDialog",
	"./_CustomViewAction"
], function(ActionFactory,MessageDialog,_CustomViewAction) {

	return ActionFactory.declare("CustomViewDelete", _CustomViewAction, {
		classController: "csi/view/customview/DeleteController",
		confirmAction: MessageDialog.BUTTON_DELETE,
		customViewAccess: true,
		customViewInstance: true,

		/**
		 * @override
		 * Don't allow deleting custom view if it is shared with roles to which you don't have access (not a problem for Administrator)
		 */
		hasAccess: function(ctx) {
			return this.inherited(arguments) && !ctx.view.getSelectedCustomView().isSharedWithRolesOfAnotherUser();
		}
	});
});